import { render, staticRenderFns } from "./header_notification.vue?vue&type=template&id=71e986f2&scoped=true"
import script from "./header_notification.vue?vue&type=script&lang=js"
export * from "./header_notification.vue?vue&type=script&lang=js"
import style0 from "./header_notification.vue?vue&type=style&index=0&id=71e986f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e986f2",
  null
  
)

export default component.exports